import { render, staticRenderFns } from "./SigninPage.vue?vue&type=template&id=9acca534"
import script from "./SigninPage.vue?vue&type=script&lang=ts"
export * from "./SigninPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports